import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=ffa5b0c6"
import script from "./ProductCard.vue?vue&type=script&lang=js"
export * from "./ProductCard.vue?vue&type=script&lang=js"
import style0 from "./ProductCard.vue?vue&type=style&index=0&id=ffa5b0c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports